import React, { useState, useMemo, useEffect } from 'react';
import '../../styles/Modal.css';
import TimeStamp from '../../utils/TimeStamp';
import quoteService from '../../services/QuoteService';

const QuoteModal = ({ isActive, onClose, onSubmit, accountName }) => {
    const [opportunityName, setOpportunityName] = useState('');
    const [quoteCustomId, setQuoteCustomId] = useState('');
    const currentDate = useMemo(() => TimeStamp.fromDate(new Date()), []);

    const isFormValid = useMemo(() => {
        return opportunityName.trim() !== '' && quoteCustomId !== '';
    }, [opportunityName, quoteCustomId]);

    useEffect(() => {
        if (isActive) {
            // Générer un nouveau quoteCustomId quand le modal s'ouvre
            const generateId = async () => {
                try {
                    const id = await quoteService.generateQuoteCustomId();
                    setQuoteCustomId(id);
                } catch (error) {
                    console.error('Erreur lors de la génération du quoteCustomId:', error);
                }
            };
            generateId();
        }
    }, [isActive]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Sauvegarde du numéro de devis avant de soumettre
            await quoteService.commitQuoteNumber();
            onSubmit({
                opportunityName,
                quoteCustomId,
                timeStamp: currentDate,
                quoteName: ''
            });
            onClose();
        } catch (error) {
            console.error('Erreur lors de la sauvegarde du numéro de devis:', error);
        }
    };

    return (
        <div className={`modal ${isActive ? 'is-active' : ''}`}>
            <div className="modal-background" onClick={onClose}></div>
            <div className="modal-card">
                <header className="modal-card-head">
                    <p className="modal-card-title">Nouveau devis pour {accountName}</p>
                    <button className="delete" aria-label="close" onClick={onClose}></button>
                </header>
                <section className="modal-card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="table-container">
                            <table className="table is-fullwidth is-striped is-hoverable mb-0">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '200px' }}>
                                            <label className="label">Projet</label>
                                        </td>
                                        <td>
                                            <input
                                                className="input"
                                                type="text"
                                                value={opportunityName}
                                                onChange={(e) => setOpportunityName(e.target.value)}
                                                placeholder="Nom du projet"
                                                required
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label className="label">Date</label>
                                        </td>
                                        <td>
                                            <input
                                                className="input"
                                                type="text"
                                                value={currentDate.toString()}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label className="label">Devis</label>
                                        </td>
                                        <td>
                                            <input
                                                className="input"
                                                type="text"
                                                value={quoteCustomId}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </form>
                </section>
                <footer className="modal-card-foot">
                    <button className="button" onClick={onClose}>Annuler</button>
                    {isFormValid && (
                        <button className="button is-primary" onClick={handleSubmit}>Créer</button>
                    )}
                </footer>
            </div>
        </div>
    );
};

export default QuoteModal;
